// extracted by mini-css-extract-plugin
export var cardIcon = "_4k-4";
export var checkboxCard = "_4k-0";
export var checkboxCardSelected = "_4k-1";
export var disabled = "_4k-2";
export var outerBorder = "_4k-3";
export var spacerMedium = "_4k-7";
export var spacerSmall = "_4k-6";
export var spacerXsmall = "_4k-5";